<template>
    <b-table
            :narrowed="true"
            :striped="true"
            :data="data"
    >
     <template slot-scope="props">
         <b-table-column label="ID" width="40" numeric field="id">{{props.row.id}}</b-table-column>
         <b-table-column label="Name" field="name">{{props.row.name}}</b-table-column>
         <b-table-column label="Tag" field="tag" width="80" centered>{{props.row.tag}}</b-table-column>
     </template>
    </b-table>
</template>

<script>
  import BTableColumn from "buefy/src/components/table/TableColumn";

  export default {
    components: {BTableColumn},
    name: "floor-list",
    props: ['floors'],
    data() {
      return {
      };
    },
    computed: {
      data() {
        if (!this.floors) {
          return [];
        }

        return this.floors;
      }
    }
  }
</script>

<style scoped>

</style>